var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 145,
    height: 67,
    viewBox: "0 0 145 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      display: "block",
      marginLeft: "auto",
      marginRight: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c0_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8,56c2.8,0,5.5,-.7,7.9,-1.9c-3.3,-2.8,-6,-5.8,-8.3,-8.8C15.6,48.2,11.3,50,8.6,51c3.2,3.1,7.4,5,12.2,5ZM6.5,48.6C8.8,47.8,13.4,46,18.6,42.8C13.3,35,10.9,27.7,10.1,24.6C6,27.8,3.3,32.8,3.3,38.5c0,3.7,1.2,7.2,3.2,10.1ZM50,65l-1.4,-.3C41.7,62.6,36,59.6,31.3,56.1C28.2,57.9,24.6,59,20.8,59C9.5,59,.3,49.8,.3,38.5C.3,27.2,9.5,17.9,20.8,17.9c6.6,0,12.5,3.2,16.2,8.1C40.7,20.9,43.9,14.8,46,7.4C42.3,9.9,36.2,14,36.2,14L34.6,11.5L50.8,.6L50,4.2C47.8,14.3,43.6,22.3,38.8,28.8c1.5,2.9,2.4,6.2,2.4,9.7c0,6.5,-3,12.2,-7.6,16c-.9,-.6,-1.7,-1.3,-2.5,-1.9c4.3,-3.2,7.1,-8.3,7.1,-14.1c0,-2.5,-.5,-4.9,-1.5,-7.1c-4.5,5.3,-9.5,9.4,-14.1,12.5c-.7,-.8,-1.2,-1.6,-1.8,-2.5c4.7,-3.1,9.8,-7.3,14.3,-12.9C31.9,23.9,26.7,21,20.8,21c-3.6,0,-6.9,1,-9.7,2.9c.7,2.6,2.9,10.2,8.5,18.3c.2,.4,.5,.8,.8,1.2c0,0,.1,.1,.1,.1c.3,.4,.6,.8,.9,1.2c2.3,3.1,5.2,6.1,8.7,8.9c.6,.6,1.3,1.1,2,1.6c4.3,3.2,9.4,5.9,15.4,7.9C46.3,61,41.3,52.2,41.3,52.2l1,-.5L50,65Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8,56C16,56,11.8,54.1,8.6,51c.4,-.1,.7,-.2,1.1,-.4c.3,-.1,.7,-.2,1,-.4q.1,0,.2,-.1c2.6,-1,5.9,-2.6,9.5,-4.8c2.3,3,5,6,8.3,8.8c-.5,.2,-1,.4,-1.5,.7c-.1,0,-.2,.1,-.4,.1c-.2,.1,-.4,.1,-.5,.2c-.2,.1,-.4,.1,-.5,.2c-.2,0,-.4,.1,-.6,.1c-.2,.1,-.3,.1,-.5,.2c-.2,0,-.4,0,-.5,.1c-.2,0,-.5,.1,-.7,.1c-.1,0,-.3,0,-.4,.1c-.3,0,-.5,0,-.8,0c-.1,.1,-.2,.1,-.4,.1c-.4,0,-.7,0,-1.1,0ZM31.1,52.6C27.7,49.9,24.9,46.9,22.6,43.9c4.6,-3.1,9.6,-7.2,14.1,-12.5c1,2.2,1.5,4.6,1.5,7.1c0,5.8,-2.8,10.9,-7.1,14.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c2_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.5,49.4c.4,0,.7,-.1,.9,-.2c.2,-.2,.3,-.5,.3,-.8c0,-.4,-.1,-.7,-.3,-.9c-.2,-.1,-.5,-.2,-.9,-.2h-.2v2.1c0,0,.1,0,.1,0q.1,0,.1,0Zm0,-3.3c.4,0,.7,-.1,.9,-.2c.2,-.2,.3,-.4,.3,-.8c0,-.3,-.1,-.6,-.3,-.8c-.2,-.1,-.5,-.2,-.9,-.2h-.2v2Zm-1.8,4.7v-8h1.6c1.1,0,1.8,.1,2.2,.5c.5,.3,.7,.9,.7,1.6c0,.5,-.1,.8,-.3,1.1c-.1,.3,-.4,.5,-.7,.7c.4,.1,.6,.3,.8,.6c.2,.3,.3,.7,.3,1.2c0,.4,-.1,.7,-.2,1c-.1,.3,-.3,.6,-.5,.8c-.2,.2,-.5,.3,-.8,.4c-.4,.1,-.9,.1,-1.6,.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c3_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3,47.7h1.6c0,-.4,-.1,-.7,-.2,-.9c-.1,-.2,-.3,-.3,-.6,-.3c-.3,0,-.5,.1,-.6,.3c-.1,.2,-.2,.5,-.2,.9Zm.8,3.2c-.7,0,-1.3,-.2,-1.6,-.7c-.4,-.5,-.6,-1.2,-.6,-2.1c0,-.8,.2,-1.5,.6,-2c.3,-.5,.9,-.8,1.6,-.8c.7,0,1.2,.3,1.6,.8c.3,.5,.5,1.2,.5,2.2v.2H66.3v.1c0,.4,.1,.7,.2,.9c.2,.2,.4,.3,.6,.3c.2,0,.3,0,.5,-.1c.1,-.1,.2,-.3,.3,-.5h1.2c-.1,.5,-.3,1,-.7,1.3c-.4,.3,-.8,.4,-1.3,.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c4_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,50.8V42.3h1.5v8.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c5_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.5,49.6c.3,0,.4,-.1,.5,-.4c.1,-.2,.2,-.6,.2,-1.2c0,-.5,-.1,-.9,-.2,-1.1c-.1,-.2,-.3,-.3,-.5,-.3c-.2,0,-.4,.1,-.5,.3c-.1,.3,-.1,.6,-.1,1.2c0,.5,0,.9,.1,1.1c.2,.3,.3,.4,.5,.4Zm0,3.7c-.6,0,-1.1,-.1,-1.5,-.5c-.3,-.3,-.5,-.8,-.5,-1.3v-.1h1.3c0,.2,0,.4,.1,.6c.2,.1,.3,.2,.6,.2c.2,0,.4,-.1,.5,-.2c.1,-.2,.2,-.4,.2,-.8V50.1c-.2,.3,-.4,.5,-.6,.6c-.2,.1,-.4,.2,-.6,.2c-.5,0,-.9,-.2,-1.2,-.7c-.3,-.5,-.4,-1.2,-.4,-2.1c0,-.9,.1,-1.5,.4,-2c.3,-.5,.7,-.7,1.2,-.7c.2,0,.5,0,.7,.2c.1,.1,.3,.4,.5,.6v-.8h1.4v5c0,1.2,-.1,2,-.5,2.3c-.3,.4,-.8,.6,-1.6,.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8,50.8V45.4h2.1v5.4Zm1,-6c-.3,0,-.6,-.1,-.8,-.2c-.2,-.2,-.4,-.4,-.4,-.6c0,-.3,.2,-.5,.4,-.6c.2,-.2,.5,-.3,.8,-.3c.4,0,.7,.1,.9,.3c.2,.1,.3,.3,.3,.6c0,.2,-.1,.4,-.3,.6c-.2,.1,-.5,.2,-.9,.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.3,49.6c.2,0,.4,-.1,.5,-.4C82.9,49,83,48.6,83,48c0,-.5,-.1,-.8,-.2,-1.1c-.1,-.2,-.3,-.3,-.6,-.3c-.2,0,-.3,.1,-.4,.3c-.1,.3,-.2,.6,-.2,1.2c0,.5,.1,.9,.2,1.1c.1,.3,.3,.4,.5,.4Zm-.6,1.3c-.5,0,-.9,-.2,-1.1,-.7c-.3,-.5,-.4,-1.2,-.4,-2.1c0,-.8,.1,-1.5,.4,-2c.3,-.5,.7,-.7,1.2,-.7c.2,0,.4,0,.6,.2c.2,.1,.4,.3,.6,.6v-.8h1.4v5.4H83V50c-.2,.3,-.4,.6,-.6,.7c-.2,.2,-.4,.2,-.7,.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4,50.8V45.4h1.4v.9c.2,-.3,.4,-.6,.7,-.7c.2,-.2,.5,-.2,.8,-.2c.4,0,.7,.1,.9,.3c.2,.3,.2,.7,.2,1.4v3.7H88V47.6c0,-.4,-.1,-.6,-.2,-.7c0,-.1,-.2,-.2,-.3,-.2c-.2,0,-.4,.1,-.4,.2c-.1,.2,-.2,.4,-.2,.7v3.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c9_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.7,64.4V56.3h3.5v1.5H61.3v1.7H63V61H61.3v3.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c10_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66,63.2c.3,0,.5,-.1,.6,-.4c.2,-.3,.2,-.6,.2,-1.1c0,-.5,0,-.9,-.2,-1.2c-.1,-.2,-.3,-.3,-.6,-.3c-.3,0,-.5,.1,-.6,.3c-.1,.3,-.2,.7,-.2,1.2c0,.5,.1,.8,.2,1.1c.1,.3,.3,.4,.6,.4Zm0,1.3c-.7,0,-1.2,-.3,-1.6,-.8c-.4,-.5,-.6,-1.2,-.6,-2c0,-.9,.2,-1.6,.6,-2.1c.4,-.5,.9,-.7,1.6,-.7c.7,0,1.2,.2,1.6,.7c.4,.5,.6,1.2,.6,2.1c0,.8,-.2,1.5,-.6,2c-.4,.5,-.9,.8,-1.6,.8Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c11_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69,64.4V59h1.4v.9c.2,-.3,.3,-.6,.5,-.8c.2,-.1,.5,-.2,.7,-.2v1.4h-.1c-.3,0,-.6,.1,-.8,.3c-.1,.2,-.2,.6,-.2,1.2v2.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c12_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.4,61.2H75c0,-.4,-.1,-.7,-.2,-.8c-.1,-.2,-.3,-.3,-.6,-.3c-.2,0,-.4,.1,-.6,.3c-.1,.2,-.2,.5,-.2,.8Zm.8,3.3c-.7,0,-1.2,-.3,-1.6,-.8c-.4,-.5,-.6,-1.1,-.6,-2c0,-.9,.2,-1.6,.6,-2.1c.4,-.5,.9,-.7,1.6,-.7c.7,0,1.2,.2,1.6,.7c.3,.5,.5,1.3,.5,2.2v.3H73.4c0,.4,.1,.7,.2,1c.2,.2,.4,.3,.7,.3c.1,0,.3,-.1,.4,-.2c.1,-.1,.2,-.2,.3,-.4h1.3c-.2,.5,-.4,.9,-.8,1.2c-.3,.3,-.8,.5,-1.3,.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c13_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2,64.4V59h2.1v5.4Zm1,-6c-.3,0,-.6,-.1,-.8,-.3C77.1,58,77,57.8,77,57.5c0,-.2,.1,-.4,.4,-.6c.2,-.2,.5,-.2,.8,-.2c.3,0,.6,0,.9,.2c.2,.2,.3,.4,.3,.6c0,.3,-.1,.5,-.3,.6c-.3,.2,-.5,.3,-.9,.3Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c14_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.7,63.2c.2,0,.3,-.2,.4,-.4c.1,-.2,.2,-.6,.2,-1.2c0,-.5,-.1,-.9,-.2,-1.1c-.1,-.3,-.2,-.4,-.5,-.4c-.2,0,-.3,.1,-.4,.4c-.1,.2,-.2,.6,-.2,1.1c0,.5,.1,.9,.2,1.2c.1,.2,.2,.4,.5,.4Zm-.1,3.7c-.6,0,-1.1,-.2,-1.5,-.5c-.3,-.3,-.5,-.8,-.5,-1.4v-.1h1.3c0,.3,0,.5,.2,.6c.1,.2,.3,.2,.5,.2c.2,0,.4,-.1,.5,-.2c.1,-.1,.2,-.4,.2,-.7V63.7c-.2,.2,-.4,.4,-.6,.6c-.2,.1,-.4,.1,-.6,.1c-.5,0,-.9,-.2,-1.2,-.7c-.2,-.4,-.4,-1.1,-.4,-2c0,-.9,.2,-1.6,.4,-2.1c.3,-.4,.7,-.7,1.2,-.7c.3,0,.5,.1,.7,.2c.2,.2,.3,.4,.5,.7V59h1.4v5c0,1.1,-.1,1.9,-.4,2.3c-.3,.4,-.9,.6,-1.7,.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c15_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8,64.4V59h1.4v.8c.2,-.3,.4,-.5,.7,-.7c.2,-.1,.5,-.2,.8,-.2c.4,0,.7,.1,.9,.4c.1,.2,.2,.7,.2,1.4v3.7H87.3V61.1c0,-.3,0,-.5,-.1,-.6c-.1,-.1,-.2,-.2,-.4,-.2c-.1,0,-.3,.1,-.4,.2c0,.1,-.1,.4,-.1,.7v3.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c16_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.2,64.4V57.8H92V56.3h4v1.5H94.8v6.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c17_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.8,64.4V59h1.4v.9c.2,-.3,.3,-.6,.5,-.8c.2,-.1,.5,-.2,.7,-.2v1.4h-.1c-.3,0,-.6,.1,-.8,.3c-.1,.2,-.2,.6,-.2,1.2v2.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c18_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101,63.2c.2,0,.4,-.2,.5,-.4c.1,-.3,.2,-.7,.2,-1.2c0,-.5,-.1,-.9,-.2,-1.1c-.1,-.2,-.3,-.4,-.5,-.4c-.3,0,-.4,.2,-.5,.4c-.1,.2,-.2,.6,-.2,1.1c0,.5,.1,.9,.2,1.2c.1,.2,.3,.4,.5,.4Zm-.5,1.3c-.6,0,-1,-.2,-1.2,-.7c-.3,-.5,-.4,-1.2,-.4,-2.1c0,-.9,.1,-1.6,.4,-2.1c.3,-.4,.7,-.7,1.2,-.7c.2,0,.4,.1,.6,.2c.2,.2,.4,.4,.6,.7V59h1.4v5.4h-1.4v-.8c-.2,.3,-.4,.5,-.6,.7c-.2,.1,-.4,.2,-.6,.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c19_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.1,63.2c.2,0,.4,-.2,.5,-.4c.1,-.2,.1,-.6,.1,-1.2c0,-.5,0,-.9,-.1,-1.1c-.1,-.3,-.3,-.4,-.5,-.4c-.3,0,-.4,.1,-.5,.4c-.1,.2,-.2,.6,-.2,1.1c0,.5,.1,.9,.2,1.2c.1,.2,.3,.4,.5,.4Zm-.6,1.3c-.5,0,-.9,-.2,-1.1,-.7c-.3,-.5,-.4,-1.2,-.4,-2.1c0,-.9,.1,-1.6,.4,-2.1c.3,-.4,.7,-.7,1.2,-.7c.2,0,.4,.1,.6,.2c.2,.2,.4,.4,.5,.6V55.8h1.5v8.6h-1.5v-.8c-.1,.3,-.3,.5,-.5,.7c-.2,.1,-.4,.2,-.7,.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c20_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.4,61.2H112c0,-.4,-.1,-.7,-.2,-.8c-.1,-.2,-.3,-.3,-.6,-.3c-.2,0,-.4,.1,-.6,.3c-.1,.2,-.2,.5,-.2,.8Zm.8,3.3c-.7,0,-1.2,-.3,-1.6,-.8c-.4,-.5,-.6,-1.1,-.6,-2c0,-.9,.2,-1.6,.6,-2.1c.4,-.5,.9,-.7,1.6,-.7c.7,0,1.2,.2,1.6,.7c.3,.5,.5,1.3,.5,2.2v.3h-2.9c0,.4,.1,.7,.2,1c.2,.2,.4,.3,.7,.3c.1,0,.3,-.1,.4,-.2c.1,-.1,.2,-.2,.3,-.4h1.3c-.2,.5,-.4,.9,-.8,1.2c-.3,.3,-.8,.5,-1.3,.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c21_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.2,61.7c-.1,-.5,-.2,-1.1,-.3,-1.7c-.1,-.7,-.2,-1.3,-.3,-2c0,.6,-.1,1.2,-.2,1.8c-.1,.7,-.2,1.3,-.3,1.9ZM116,64.4l1.8,-8.1h1.7l1.8,8.1h-1.6L119.4,63h-1.6l-.2,1.4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c22_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.7,63.2c.2,0,.4,-.2,.5,-.4c.1,-.2,.1,-.6,.1,-1.2c0,-.5,0,-.9,-.1,-1.1c-.1,-.3,-.3,-.4,-.5,-.4c-.2,0,-.4,.1,-.5,.4c-.1,.2,-.1,.6,-.1,1.1c0,.5,0,.9,.1,1.2c.1,.2,.3,.4,.5,.4Zm0,3.7c-.7,0,-1.2,-.2,-1.5,-.5c-.4,-.3,-.5,-.8,-.5,-1.4v-.1h1.2c0,.3,.1,.5,.2,.6c.1,.2,.3,.2,.5,.2c.3,0,.5,-.1,.6,-.2c.1,-.1,.1,-.4,.1,-.7V63.7c-.1,.2,-.3,.4,-.5,.6c-.2,.1,-.4,.1,-.6,.1c-.5,0,-.9,-.2,-1.2,-.7c-.3,-.4,-.4,-1.1,-.4,-2c0,-.9,.1,-1.6,.4,-2.1c.3,-.4,.7,-.7,1.2,-.7c.2,0,.4,.1,.6,.2c.2,.2,.4,.4,.5,.7V59h1.5v5c0,1.1,-.2,1.9,-.5,2.3c-.3,.4,-.8,.6,-1.6,.6Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c23_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.1,61.2h1.5c0,-.4,0,-.7,-.2,-.8c-.1,-.2,-.3,-.3,-.6,-.3c-.2,0,-.4,.1,-.5,.3c-.2,.2,-.2,.5,-.2,.8Zm.7,3.3c-.7,0,-1.2,-.3,-1.6,-.8c-.4,-.5,-.6,-1.1,-.6,-2c0,-.9,.2,-1.6,.6,-2.1c.4,-.5,.9,-.7,1.6,-.7c.7,0,1.2,.2,1.6,.7c.4,.5,.5,1.3,.5,2.2v.3h-2.8c0,.4,0,.7,.2,1c.1,.2,.3,.3,.6,.3c.1,0,.3,-.1,.4,-.2c.1,-.1,.2,-.2,.3,-.4h1.3c-.1,.5,-.4,.9,-.8,1.2c-.3,.3,-.8,.5,-1.3,.5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c24_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.7,64.4V59h1.4v.8c.2,-.3,.4,-.5,.6,-.7c.3,-.1,.5,-.2,.9,-.2c.4,0,.7,.1,.8,.4c.2,.2,.3,.7,.3,1.4v3.7h-1.5V61.1c0,-.3,0,-.5,-.1,-.6c-.1,-.1,-.2,-.2,-.4,-.2c-.2,0,-.3,.1,-.4,.2c-.1,.1,-.1,.4,-.1,.7v3.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c25_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.5,64.5c-.6,0,-1.1,-.3,-1.5,-.8c-.3,-.5,-.5,-1.2,-.5,-2c0,-.9,.2,-1.6,.5,-2.1c.4,-.5,.9,-.7,1.5,-.7c.2,0,.4,0,.6,0c.1,.1,.3,.1,.5,.2v1.4c-.2,-.1,-.3,-.1,-.4,-.2c-.1,0,-.2,0,-.3,0c-.3,0,-.5,.1,-.7,.3c-.2,.3,-.2,.6,-.2,1c0,.5,0,.8,.2,1.1c.2,.2,.4,.3,.7,.3c.1,0,.3,0,.4,0c.1,-.1,.2,-.2,.3,-.2v1.4c-.2,.1,-.4,.2,-.5,.2c-.2,.1,-.4,.1,-.6,.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c26_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.5,66.6l.7,-2.2L139.8,59h1.4l.6,2.4c0,.1,0,.3,0,.5c0,.1,.1,.3,.1,.5c0,-.4,0,-.7,.1,-.8c0,-.1,0,-.2,0,-.3l.5,-2.3H144l-2,7.6Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,67 L145,67 L145,0 Z ",
    fill: "#FFFFFF",
    stroke: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.2,-7H58.4V72.7H-7.2Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c1_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,23.7H45.9v40H1Z",
    className: "g1_1",
    fill: "#F0A93F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c2_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1,35.1H71.9V58.5H52.1Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c3_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2,37.7H76.8V58.6H57.2Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4,34.6H79.1V58.5H62.4Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c5_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8,37.7H84.2V61H64.8Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70,35.5H87.7v23H70Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.5,37.7H92V58.6H72.5Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8,37.7H97.1V58.5H77.8Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c9_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1,48.7H70.8V72H52.1Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c10_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1,51.2H75.9V72.1H56.1Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c11_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4,51.2H79.3V72H61.4Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c12_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3,51.2H84V72.1H64.3Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c13_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4,49H87.1V72H69.4Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c14_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9,51.3H91.4V74.5H71.9Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c15_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.2,51.3H96.5V72H77.2Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c16_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.3,48.7h19.4V72H84.3Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c17_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2,51.2h17.9V72H88.2Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c18_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2,51.3h19.5V72.1H91.2Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c19_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3,48.2h19.5V72.1H96.3Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c20_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.3,51.2H121V72.1H101.3Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c21_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.3,48.7h20.6V72H108.3Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c22_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.9,51.3h19.5V74.5H113.9Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c23_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119,51.2h19.6V72.1H119Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c24_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124,51.3h19.3V72H124Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c25_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.8,51.2h18.4V72.1H128.8Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c26_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.1,51.3h19.5V74.2H132.1Z",
    className: "g0_1",
    fill: "#8D0B3D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1a5c9cd9db7942a16b428bb270973a87.svg";
export { ForwardRef as ReactComponent };